import { Modelo } from '@ext/index';
import * as Types from './Curso.types';
import moment, { Moment } from 'moment';
import { Recurso } from '@/__env/lib/Cursos/Recursos';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { isArray } from 'util';

export class ICurso extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Guid: string = '';
    public Id: number  = 0;
    public Estado: Types.Estados = Types.Estados.Creado;
    public Tipo: Types.Tipos = Types.Tipos.Ventas;
    public Titulo: string = '';
    public Descripcion: string = '';
    public Link: string = '';

    public Preguntas: Pregunta[] = [];
    public Recursos: Recurso[] = [];


    public getJson(): any
    {
        let json: any = {};

        json.estado = this.Estado.Id;
        json.tipo= this.Tipo.Id;
        json.titulo = this.Titulo;
        json.descripcion = this.Descripcion;

        json.recursos = this.Recursos.map( x => x.getJson() )
        json.preguntas = this.Preguntas.map( x => x.getJson() )

        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Estado = Types.Estados.toTipo( this.Json.estado );
        this.Tipo = Types.Tipos.toTipo( this.Json.tipo );
        this.Titulo = !this.Json.titulo ? '' : this.Json.titulo;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;
        this.Link = !this.Json.link ? '' : this.Json.link;

        if ( isArray( this.Json.preguntas ) )
        {
            for ( let e of this.Json.preguntas )
            {
                this.Preguntas.add( new Pregunta( e ) );
            }
        }

        if ( isArray( this.Json.recursos) )
        {
            for ( let e of this.Json.recursos)
            {
                this.Recursos.add( new Recurso( e ) );
            }
        }


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: ICurso )
    {
        this.Model = Model;
    }

    public Model: ICurso;
}